<mat-card class="card">
    <div>
        <iframe type="text/html"
                [src]="video.embedUrl"
                frameborder="0"></iframe>
    </div>
    <mat-card-content>
        <div class="d-flex">
            <div class="description">
                {{video.description}}
            </div>
            <div *ngIf="isSuperAdmin" class="action-button">
                <img src="assets/img/icons/edit.svg" (click)="edit(video)"/>
                <img src="assets/img/icons/delete2.svg" (click)="delete(video)"/>
            </div>
        </div>
    </mat-card-content>
</mat-card>